import { render, staticRenderFns } from "./Proveedores.vue?vue&type=template&id=0a7fa640&"
import script from "./Proveedores.vue?vue&type=script&lang=ts&"
export * from "./Proveedores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports